/** @jsxImportSource @emotion/react */

export const openSlackPopup = (
  callback?: (botToken: string, userId: string, teamName: string, workspaceId: string) => void
) => {
  const url = `https://slack.com/oauth/v2/authorize?client_id=${process.env.REACT_APP_SLACK_CLIENT_ID}&scope=app_mentions:read,channels:history,channels:read,chat:write,chat:write.public,commands,users:read,users:read.email,groups:read&user_scope=chat:write`;

  const popup = window.open(url, "slack");
  let handled = false;

  const handleMessage = async (event: MessageEvent) => {
    if (handled) return;

    const { botToken, userId, teamName, workspaceId } = event.data;

    if (!botToken || !userId) return;

    handled = true;
    cleanup();
    callback?.(botToken, userId, teamName, workspaceId);
  };

  const cleanup = () => {
    window.removeEventListener("message", handleMessage);
    try {
      popup?.close();
    } catch {}
  };

  const timer = setInterval(() => {
    try {
      if (popup?.closed) {
        clearInterval(timer);
        window.removeEventListener("message", handleMessage);
      }
    } catch (error) {
      console.error("Error detecting popup closed", error);
    }
  }, 1000);

  window.addEventListener("message", handleMessage);
};
